import { render, staticRenderFns } from "./setProduct.vue?vue&type=template&id=683e17b2&scoped=true"
import script from "./setProduct.vue?vue&type=script&lang=js"
export * from "./setProduct.vue?vue&type=script&lang=js"
import style0 from "./setProduct.vue?vue&type=style&index=0&id=683e17b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683e17b2",
  null
  
)

export default component.exports